import { CommissionCategory } from './actions';
import { CommissionState } from './reducer';

const selectSlice = (state: any): CommissionState => state.commissionManager;

export const getCommissionList = (state: any): CommissionCategory[] =>
  selectSlice(state)?.list ?? [];

export const getCommissionLoading = (state: any): boolean =>
  !!selectSlice(state)?.loading;

export const getCommissionSaving = (state: any): boolean =>
  !!selectSlice(state)?.saving;

export const getCommissionError = (state: any): string | undefined =>
  selectSlice(state)?.error;

export const getFilterName = (state: any): string =>
  selectSlice(state)?.filterName ?? '';

export const getFilteredCommissionList = (state: any): CommissionCategory[] => {
  const list = getCommissionList(state);
  const q = (getFilterName(state) || '').trim().toLowerCase();

  let data = list;
  if (q) data = data.filter((c) => (c.name ?? '').toLowerCase().includes(q));
  return [...data].sort((a, b) => (a.name ?? '').localeCompare(b.name ?? ''));
};